<span><strong v-if="isSumRow">{{ filteredValue }}</strong><template v-else>{{ filteredValue }}</template></span>